import JSZip from 'jszip'

function safeName(value, fallback) {
  const clean = String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9_-]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, 60)
  return clean || fallback
}

function extensionFrom(url, mime) {
  const path = String(url || '').split('?')[0]
  const match = path.match(/\.([a-z0-9]{2,5})$/i)
  if (match) return match[1].toLowerCase()
  if (mime === 'image/png') return 'png'
  if (mime === 'image/webp') return 'webp'
  if (mime === 'image/gif') return 'gif'
  return 'jpg'
}

function saveBlob(blob, filename) {
  const objectUrl = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = objectUrl
  link.download = filename
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.setTimeout(() => URL.revokeObjectURL(objectUrl), 1500)
}

function cloudinaryAttachmentUrl(url, filename) {
  try {
    const parsed = new URL(url)
    if (!parsed.hostname.endsWith('res.cloudinary.com')) return ''
    const marker = '/upload/'
    const index = parsed.pathname.indexOf(marker)
    if (index < 0) return ''
    const stem = safeName(filename.replace(/\.[^.]+$/, ''), 'foto')
    parsed.pathname =
      parsed.pathname.slice(0, index + marker.length) +
      `fl_attachment:${stem}/` +
      parsed.pathname.slice(index + marker.length)
    return parsed.toString()
  } catch {
    return ''
  }
}

export function zipFileName(label) {
  return `${safeName(label, 'produto')}-fotos.zip`
}

export function photoFileName(label, index, url, mime) {
  const base = safeName(label, 'foto')
  const ext = extensionFrom(url, mime)
  return `${base}-${String(index + 1).padStart(2, '0')}.${ext}`
}

async function fetchImageBlob(url) {
  const response = await fetch(url, { mode: 'cors', credentials: 'omit' })
  if (!response.ok) {
    throw new Error('Falha ao baixar a imagem')
  }
  return response.blob()
}

export async function downloadOnePhoto(url, filename) {
  try {
    const blob = await fetchImageBlob(url)
    saveBlob(blob, filename)
  } catch (err) {
    const attachment = cloudinaryAttachmentUrl(url, filename)
    if (!attachment) throw err
    const link = document.createElement('a')
    link.href = attachment
    link.rel = 'noopener'
    document.body.appendChild(link)
    link.click()
    link.remove()
  }
}

export async function downloadPhotosZip(images, zipName, label) {
  const zip = new JSZip()
  const used = new Set()
  for (let index = 0; index < images.length; index += 1) {
    const url = images[index]?.image_url
    if (!url) continue
    const blob = await fetchImageBlob(url)
    let name = photoFileName(label, index, url, blob.type)
    while (used.has(name)) {
      name = name.replace(/(\.[^.]+)$/, `-${index + 1}$1`)
    }
    used.add(name)
    zip.file(name, blob)
  }
  if (used.size === 0) {
    throw new Error('Nenhuma foto para baixar')
  }
  const archive = await zip.generateAsync({ type: 'blob' })
  saveBlob(archive, zipName)
}
